import { render, staticRenderFns } from "./Content4NewsBox.vue?vue&type=template&id=2e589bcf&scoped=true&"
import script from "./Content4NewsBox.vue?vue&type=script&lang=js&"
export * from "./Content4NewsBox.vue?vue&type=script&lang=js&"
import style0 from "./Content4NewsBox.vue?vue&type=style&index=0&id=2e589bcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e589bcf",
  null
  
)

export default component.exports